import { render, staticRenderFns } from "./CategoriesAdd.vue?vue&type=template&id=39447765"
import script from "./CategoriesAdd.vue?vue&type=script&lang=js"
export * from "./CategoriesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports